export const YYB_APP_IDS = ['45', '48', '70'];
